module.exports = __webpack_public_path__ + "static/Nueng@2x.e749037d.png";